import React, { Component } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import './Pricing.css';
import CryptoMascot from '../../../assets/journaler/solutions/mr-journaler.png';
import ComparePlans from './components/ComparePlans';
import PlanView from './components/PlanView';
import SelectOptionCurrency from './components/SelectOptionCurrency';

// unused legacy data removed

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: 'monthly',
      currency: 'aud',
      countryName: '',
      companyProfile: 79
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    var url = 'https://api.ipregistry.co/?key=vav52tym9lvtoa89';
    let country = await fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {

        return payload.location.country.name

      });

    this.setState({ countryName: country });
    if (country === 'Australia') {
      this.setState(
        {
          currency: 'aud',
          companyProfile: 79
        });
    }
    else {
      this.setState(
        {
          currency: 'usd',
          companyProfile: 49
        });
    }
  }

  onHandlePrice = (e) => {
    this.setState({ price: e });
  };

  showYearlyPrice = (e) => {
    this.setState({ price: 'yearly' });
  };
  checkicon = (e) => {
    if (e === true) {
      return <FaCheck style={{ color: "#226E9D" }} />
    }
    else if (e === false) {
      return <FaTimes />
    }
    else {
      return e
    }
  }


  fnGetPriceFrequency = () => {
    if (this.state.price === 'monthly') {
      return (
        <th scope="col" class='align-middle'>
          <div className='monthly-mobile' style={{ paddingTop: '15px' }}>Monthly Subscription</div>
          <div className='yearly-mobile'>Yearly Subscription</div>
          <p className='italictextCardbody-mobile' >Subscribe & Save 10%</p>
        </th>
      )
    }
    else {
      return (
        <th scope="col" class='align-middle'>
          <div className='monthly-mobile' style={{ paddingTop: '15px' }}>Yearly Subscription</div>
          <div className='yearly-mobile'>Monthly Subscription</div>
          <p className='italictextCardbody-mobile' >Subscribe & Save 10%</p>
        </th>
      )
    }
  }

  handleOnChangeCurrency = (item) => {

    this.setState(
      {
        currency: item,
        companyProfile: item === 'aud' ? 79 : 49
      });
  }


  render() {
    return (
      <div>
        <div className='pricing'>
          pricing
        </div>
        <div className='d-flex  justify-content-center pt-3 pt-sm-5 pt-lg-5 pt-xl-5'>
          <div className='header-journaler '>
            Find the right <span className='text-journaler'>Journaler </span> plan for you
          </div>
        </div>
        <div className='justify-content-center pt-3 pt-sm-5 pt-lg-5 pt-xl-5'>
          <div className='sub-header-journaler pb-1'>
            30 day free trial available for all plans
          </div>
          <div className='sub-header-journaler'>
            Change/cancel your subscription anytime
          </div>
        </div>
        <div>
          <div className='container pricingControls d-none d-sm-flex flex-column justify-content-between align-items-center pt-5 my-3'>
            <div className='d-flex flex-row align-items-center justify-content-between mb-4 w-75'>
              <div className='pricingControlLabel mr-3'>Which currency would you prefer to see?</div>
              <SelectOptionCurrency currency={this.handleOnChangeCurrency} valuecurrency={this.state.currency} />
            </div>
            <div className='d-flex flex-row justify-content-between w-75'>
              <div className='pricingControlLabel'>How do you want to be billed?</div>
              <div className='billingOptions'>
                <label className='radioOption'>
                  <input
                    type='radio'
                    name='billing'
                    checked={this.state.price === 'yearly'}
                    onChange={() => this.onHandlePrice('yearly')}
                  />
                  <span>Yearly</span>
                  <span className='discountBadge'>Up to 20% off</span>
                </label>
                <label className='radioOption'>
                  <input
                    type='radio'
                    name='billing'
                    checked={this.state.price === 'monthly'}
                    onChange={() => this.onHandlePrice('monthly')}
                  />
                  <span>Monthly</span>
                </label>
              </div>
            </div>
          </div>
          <div className='mobile container pricingControls'>
            <div className='pt-3 d-flex'>
              <div className='pricingControlLabel'>Which currency would you prefer to see?</div>
              <SelectOptionCurrency currency={this.handleOnChangeCurrency} valuecurrency={this.state.currency} />
            </div>
            <div className='pt-4'>
              <div className='pricingControlLabel'>How do you want to be billed?</div>
              <div className='billingOptions pb-3'>
                <label className='radioOption'>
                  <input
                    type='radio'
                    name='billing-mobile'
                    checked={this.state.price === 'yearly'}
                    onChange={() => this.onHandlePrice('yearly')}
                  />
                  <span>Yearly</span>
                  <span className='discountBadge'>Up to 20% off</span>
                </label>
                <label className='radioOption'>
                  <input
                    type='radio'
                    name='billing-mobile'
                    checked={this.state.price === 'monthly'}
                    onChange={() => this.onHandlePrice('monthly')}
                  />
                  <span>Monthly</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.currency === 'usd' && <div className='text-center pb-3'>USD prices are based on exchange rate as billing is in AUD</div>
        }
        <div className='container'>
          <PlanView durationMode={this.state.price} currency={this.state.currency} />
        </div>
        <div className='container pb-4'>
          <div className='row'>
            <div className='col-12 col-lg-6 mb-3 mb-lg-0'>
              <div className='freeTrialContainer h-100'>
                <div className='freeTrialTitle'>30 days free trial</div>
                <div className='freeTrialDesc'>
                  Explore all features free for 30 days – no payment required, upgrade anytime!
                </div>
                <div className='d-flex justify-content-start'>
                  <a href='https://journaler.aem.ac/user/register' className='btcContactUs'>
                    Start a free trial
                  </a>
                </div>
              </div>
            </div>
            <div className='col-12 col-lg-6'>
              <div className='containerEnterprise h-100'>
              <div>
                    <div className='enterprise'>
                      Enterprise
                    </div>
                    <div className='subEnterprise'>
                      Gain access to unlimited transactions, customizable features, API access, and more
                    </div>
                  </div>
                  <div>
                    <div>
                      <a href='/contact' className='btcContactUs'>
                        Contact us
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div className='container pb-5'>
          <div className='cryptoBanner row align-items-center'>
            <div className='col-12 col-md-2 d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
              <img src={CryptoMascot} alt='crypto mascot' className='cryptoImage' />
            </div>
            <div className='col-12 col-md-10'>
              <div className='cryptoTitle'>Unlock your annual subscription with crypto!</div>
              <div className='cryptoDesc'>
                Enjoy 20% off your Journaler subscription when you pay with Bitcoin or Ethereum through Xverse or MetaMask.
              </div>
              <div className='pt-3'>
                <a href='/journaler/signup-form' className='btcContactUs'>
                  Get started now
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='support pt-3'>
          <div className='container'>
            <h2 className='text-center title-ournetwork pt-5'>Support for</h2>
            <div className='text-center title-ournetwork' ><span className='currency20'>20,000+</span> cryptocurrencies</div>
          </div>
        </div>
        <ComparePlans className="pb-5" durationMode={this.state.price} currency={this.state.currency} />
        <div className='container pt-5'>
          <div className='freeTrialContainer'>
            <div className='row align-items-center'>
              <div className='col-12 col-md-9'>
                <div className='freeTrialTitle'>30 days free trial</div>
                <div className='freeTrialDesc'>
                  Explore all features free for 30 days – no payment required, upgrade anytime!
                </div>
              </div>
              <div className='col-12 col-md-3 d-flex justify-content-md-end justify-content-start'>
                <a href='https://journaler.aem.ac/user/register' className='btcContactUs'>
                  Start a free trial
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='container pb-5 pt-5'>
          <div className='containerEnterprise'>
            <div className='row align-items-center'>
              <div className='col-12 col-lg-8'>
                <div className='enterprise'>
                  Adding company profile
                </div>
                <div className='subEnterprise pt-3'>
                  Add a company profile and invite multi-users from the same organization
                </div>
              </div>
              <div className='col-12 col-lg-4'>
                <div className='d-flex flex-row justify-content-end align-items-center'>
                  <div className='startingFromLabel mr-3'>Starting from</div>
                  <div className='startingFromPrice'>${this.state.companyProfile}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Pricing);
